(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6199],{

/***/ 72175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CalendarClock; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84297);
/**
 * lucide-react v0.243.0 - ISC
 */



const CalendarClock = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("CalendarClock", [
  [
    "path",
    {
      d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5",
      key: "1osxxc"
    }
  ],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M3 10h5", key: "r794hk" }],
  ["path", { d: "M17.5 17.5 16 16.25V14", key: "re2vv1" }],
  ["path", { d: "M22 16a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z", key: "ame013" }]
]);


//# sourceMappingURL=calendar-clock.js.map


/***/ }),

/***/ 57672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CalendarPlus; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84297);
/**
 * lucide-react v0.243.0 - ISC
 */



const CalendarPlus = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("CalendarPlus", [
  [
    "path",
    {
      d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8",
      key: "3spt84"
    }
  ],
  ["line", { x1: "16", x2: "16", y1: "2", y2: "6", key: "m3sa8f" }],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "6", key: "18kwsl" }],
  ["line", { x1: "3", x2: "21", y1: "10", y2: "10", key: "xt86sb" }],
  ["line", { x1: "19", x2: "19", y1: "16", y2: "22", key: "1ttwzi" }],
  ["line", { x1: "16", x2: "22", y1: "19", y2: "19", key: "1g9955" }]
]);


//# sourceMappingURL=calendar-plus.js.map


/***/ }),

/***/ 86871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Clock4; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84297);
/**
 * lucide-react v0.243.0 - ISC
 */



const Clock4 = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("Clock4", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
]);


//# sourceMappingURL=clock-4.js.map


/***/ }),

/***/ 49525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Users; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84297);
/**
 * lucide-react v0.243.0 - ISC
 */



const Users = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("Users", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
  ["path", { d: "M16 3.13a4 4 0 0 1 0 7.75", key: "1da9ce" }]
]);


//# sourceMappingURL=users.js.map


/***/ }),

/***/ 36869:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case/[id]",
      function () {
        return __webpack_require__(18037);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useAddToCalendar; }
/* harmony export */ });
/* harmony import */ var _util_cases__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65105);
/* harmony import */ var _util_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94811);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var useAddToCalendar = function(caseId) {
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        (0,_util_cases__WEBPACK_IMPORTED_MODULE_0__/* .fetchCalendarInvite */ .Dq)(caseId).then(function(blob) {
            if (blob && blob.type === "text/calendar") {
                (0,_util_util__WEBPACK_IMPORTED_MODULE_1__/* .downloadFile */ .Sv)(blob, "invite.ics");
            }
        }).catch(function(err) {
            console.error(err);
        });
    }, [
        caseId
    ]);
};


/***/ }),

/***/ 82698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _features_thunks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32132);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46035);
/* harmony import */ var _features_casesSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94916);
/* harmony import */ var _util_format__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16685);
/* harmony import */ var _components_UserAvatar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8222);
/* harmony import */ var _components_ui_dialog__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70499);








var CaseParticipantsModal = function(param) {
    var open = param.open, onOpenChange = param.onOpenChange, caseId = param.caseId;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var currentCase = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_features_casesSlice__WEBPACK_IMPORTED_MODULE_4__/* .selectCaseById */ .pJ)(state, caseId || "");
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (caseId) {
            dispatch((0,_features_thunks__WEBPACK_IMPORTED_MODULE_2__/* .fetchCasesById */ .QQ)({
                caseId: caseId
            }));
        }
    }, [
        dispatch,
        caseId
    ]);
    if (!caseId || !currentCase) {
        return null;
    }
    var participants = (currentCase.participants || []).filter(function(u) {
        return u.id;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_7__/* .Dialog */ .Vq, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_7__/* .DialogContent */ .cZ, {
            className: "sm:max-w-[425px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_7__/* .DialogHeader */ .fK, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_7__/* .DialogTitle */ .$N, {
                            children: "Registered members"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_dialog__WEBPACK_IMPORTED_MODULE_7__/* .DialogDescription */ .Be, {
                            children: [
                                currentCase.register_count,
                                "/",
                                currentCase.register_max
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col gap-4 py-4 h-full",
                    children: [
                        participants.length === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-muted-foreground text-center",
                            children: "No participants yet"
                        }) : null,
                        participants.map(function(u) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center space-x-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UserAvatar__WEBPACK_IMPORTED_MODULE_6__/* .UserAvatar */ .Y, {
                                        userId: u === null || u === void 0 ? void 0 : u.id,
                                        className: "h-12 w-12"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: "text-sm font-medium leading-none",
                                                children: [
                                                    u.first_name,
                                                    " ",
                                                    u.last_name
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: "text-sm text-muted-foreground",
                                                children: [
                                                    "Member since: ",
                                                    (0,_util_format__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)({
                                                        ts: u.created,
                                                        format: _util_format__WEBPACK_IMPORTED_MODULE_5__/* .FormatName.Medium */ .G9.Medium
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, u.id);
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CaseParticipantsModal);


/***/ }),

/***/ 95348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _features_thunks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32132);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46035);
/* harmony import */ var _features_casesSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94916);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1438);
/* harmony import */ var _util_auth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19475);
/* harmony import */ var _util_hooks_useRerenderInterval__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64358);
/* harmony import */ var _util_cases__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65105);
/* harmony import */ var _components_ui_button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35739);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(57672);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(23217);
/* harmony import */ var _components_AddCaseToCalendarLink__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2902);
/* harmony import */ var _components_ui_tooltip__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5734);
/* harmony import */ var _components_ui_use_toast__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5271);














var RegisterButton = function(param) {
    var caseId = param.caseId, _textRegister = param.textRegister, textRegister = _textRegister === void 0 ? "Register" : _textRegister, _textInterested = param.textInterested, textInterested = _textInterested === void 0 ? "I am interested" : _textInterested, _textJoin = param.textJoin, textJoin = _textJoin === void 0 ? "Join the session" : _textJoin, onRegisterClick = param.onRegisterClick, onUnregisterClick = param.onUnregisterClick;
    var currentCase = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_features_casesSlice__WEBPACK_IMPORTED_MODULE_4__/* .selectCaseById */ .pJ)(state, caseId);
    });
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var auth = (0,_util_auth__WEBPACK_IMPORTED_MODULE_6__/* .useAuth */ .aC)();
    var handleAddToCalendar = (0,_components_AddCaseToCalendarLink__WEBPACK_IMPORTED_MODULE_10__/* .useAddToCalendar */ .U)(caseId);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loading = ref[0], setLoading = ref[1];
    //we rerender components to properly show join case button
    (0,_util_hooks_useRerenderInterval__WEBPACK_IMPORTED_MODULE_7__/* .useRerenderInterval */ .P)(30000);
    if (!currentCase) {
        return null;
    }
    var userId = auth.user ? auth.user.id : undefined;
    var user_participant = currentCase.user_participant, zoom_us_link = currentCase.zoom_us_link, scheduled_to = currentCase.scheduled_to, register_max = currentCase.register_max, register_count = currentCase.register_count, duration = currentCase.duration;
    var showJoinButton = (0,_util_cases__WEBPACK_IMPORTED_MODULE_8__/* .shouldShowJoinCaseButton */ .rC)({
        scheduled_to: scheduled_to,
        user_participant: user_participant,
        zoom_us_link: zoom_us_link,
        duration: duration
    });
    var showUnregisterButton = !showJoinButton && user_participant;
    var showRegisterButton = !user_participant;
    var isCaseAlreadyStarted = scheduled_to && scheduled_to < Date.now() / 1000;
    var isExpired = !!(scheduled_to && scheduled_to + (duration || 90) * 60 < Date.now() / 1000);
    var isTentative = currentCase.state === _constants__WEBPACK_IMPORTED_MODULE_5__/* .CaseStatuses.TENTATIVE */ .HM.TENTATIVE;
    var isPartOfSubscription = auth.isAuthenticated && auth.isIncludedInSubscription(_constants__WEBPACK_IMPORTED_MODULE_5__/* .PaymentPlanFeatures.live_sessions */ .TC.live_sessions);
    var isRegistrationDisabled = isCaseAlreadyStarted || !isPartOfSubscription;
    var isUnregisterDisabled = isExpired;
    var handleError = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(response) {
        var ref;
        setLoading(false);
        if (response === null || response === void 0 ? void 0 : (ref = response.error) === null || ref === void 0 ? void 0 : ref.message) {
            alert(response.error.message);
        }
    }, []);
    if (showUnregisterButton) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex gap-1",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_tooltip__WEBPACK_IMPORTED_MODULE_11__/* .TooltipProvider */ .pn, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_tooltip__WEBPACK_IMPORTED_MODULE_11__/* .Tooltip */ .u, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_tooltip__WEBPACK_IMPORTED_MODULE_11__/* .TooltipTrigger */ .aJ, {
                                asChild: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .z, {
                                    variant: "outline",
                                    size: "icon",
                                    onClick: handleAddToCalendar,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        className: "w-4 h-4"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_tooltip__WEBPACK_IMPORTED_MODULE_11__/* .TooltipContent */ ._v, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Add to calendar"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_button__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .z, {
                    variant: "outline",
                    disabled: loading || isUnregisterDisabled,
                    size: "lg",
                    onClick: function() {
                        setLoading(true);
                        dispatch((0,_features_thunks__WEBPACK_IMPORTED_MODULE_2__/* .toggleCaseRegistration */ .u9)({
                            caseId: caseId,
                            userId: userId
                        })).then(handleError).catch(function() {
                            setLoading(false);
                        });
                        onUnregisterClick && onUnregisterClick(caseId);
                    },
                    children: [
                        loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            className: "animate-spin"
                        }) : null,
                        "Unregister"
                    ]
                })
            ]
        });
    }
    if (showJoinButton) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .z, {
            disabled: !auth.isIncludedInSubscription(_constants__WEBPACK_IMPORTED_MODULE_5__/* .PaymentPlanFeatures.live_sessions */ .TC.live_sessions),
            variant: !showJoinButton ? "outline" : "default",
            size: "lg",
            asChild: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: zoom_us_link,
                children: textJoin
            })
        });
    }
    var isAllSpotsTaken = register_count && register_max && register_count >= register_max;
    if (showRegisterButton) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_button__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .z, {
            disabled: isRegistrationDisabled || loading,
            size: "lg",
            onClick: function() {
                if (isAllSpotsTaken) {
                    (0,_components_ui_use_toast__WEBPACK_IMPORTED_MODULE_12__/* .toast */ .Am)({
                        title: "All seats taken",
                        description: "All seats are currently taken. Please check back later to see if any seats become available."
                    });
                    return;
                }
                if (isCaseAlreadyStarted) {
                    (0,_components_ui_use_toast__WEBPACK_IMPORTED_MODULE_12__/* .toast */ .Am)({
                        title: "Case already started",
                        description: "You can't register for a case that has already started"
                    });
                    return;
                }
                if (auth.isAuthenticated) {
                    setLoading(true);
                    // @ts-ignore
                    dispatch((0,_features_thunks__WEBPACK_IMPORTED_MODULE_2__/* .toggleCaseRegistration */ .u9)({
                        caseId: caseId,
                        userId: userId
                    })).then(handleError).catch(function() {
                        setLoading(false);
                    });
                    onRegisterClick && onRegisterClick(caseId);
                } else {
                    auth.redirectToLogin({
                        next: "/case/".concat(caseId)
                    });
                }
            },
            children: [
                loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    className: "animate-spin"
                }) : null,
                isAllSpotsTaken ? "All seats taken" : isTentative ? textInterested : textRegister
            ]
        });
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (RegisterButton);


/***/ }),

/***/ 5734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_v": function() { return /* binding */ TooltipContent; },
/* harmony export */   "aJ": function() { return /* binding */ TooltipTrigger; },
/* harmony export */   "pn": function() { return /* binding */ TooltipProvider; },
/* harmony export */   "u": function() { return /* binding */ Tooltip; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66908);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74183);
"use client";






var TooltipProvider = _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .Provider */ .zt;
var Tooltip = _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .Root */ .fC;
var TooltipTrigger = _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .Trigger */ .xz;
var TooltipContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, _sideOffset = _param.sideOffset, sideOffset = _sideOffset === void 0 ? 4 : _sideOffset, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "sideOffset"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .Content */ .VY, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        sideOffset: sideOffset,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className)
    }, props));
});
TooltipContent.displayName = _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .Content.displayName */ .VY.displayName;



/***/ }),

/***/ 18037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./features/thunks.ts
var thunks = __webpack_require__(32132);
// EXTERNAL MODULE: ./features/casesSlice.ts
var casesSlice = __webpack_require__(94916);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(46035);
// EXTERNAL MODULE: ./components/SeoTags.tsx
var SeoTags = __webpack_require__(47460);
// EXTERNAL MODULE: ./components/ContentSection.tsx + 2 modules
var ContentSection = __webpack_require__(5895);
// EXTERNAL MODULE: ./util/video.js
var video = __webpack_require__(2630);
// EXTERNAL MODULE: ./components/cards/VideoCard.tsx
var VideoCard = __webpack_require__(84889);
// EXTERNAL MODULE: ./util/format.ts + 9 modules
var format = __webpack_require__(16685);
// EXTERNAL MODULE: ./components/forms/AddReactionForm.tsx
var AddReactionForm = __webpack_require__(18091);
// EXTERNAL MODULE: ./util/auth.tsx + 1 modules
var util_auth = __webpack_require__(19475);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(1438);
// EXTERNAL MODULE: ./components/Case/CaseParticipantsModal.tsx
var CaseParticipantsModal = __webpack_require__(82698);
// EXTERNAL MODULE: ./components/GiveFeedbackCta.tsx
var GiveFeedbackCta = __webpack_require__(76102);
// EXTERNAL MODULE: ./features/timezoneSlice.js
var timezoneSlice = __webpack_require__(70118);
// EXTERNAL MODULE: ./components/RegisterButton.tsx
var RegisterButton = __webpack_require__(95348);
// EXTERNAL MODULE: ./components/SigninConditionalRenderer.tsx + 1 modules
var SigninConditionalRenderer = __webpack_require__(11340);
// EXTERNAL MODULE: ./util/hooks/useTrainingPlan.ts
var useTrainingPlan = __webpack_require__(98688);
// EXTERNAL MODULE: ./features/commentsSlice.js
var commentsSlice = __webpack_require__(12763);
// EXTERNAL MODULE: ./components/ui/badge.tsx
var badge = __webpack_require__(95034);
// EXTERNAL MODULE: ./components/UserAvatar.tsx
var UserAvatar = __webpack_require__(8222);
// EXTERNAL MODULE: ./components/CommentsDialog.tsx
var CommentsDialog = __webpack_require__(1979);
// EXTERNAL MODULE: ./components/CommentsList.tsx
var CommentsList = __webpack_require__(95642);
;// CONCATENATED MODULE: ./components/Case/CommentsDrawer.tsx






var CommentsDrawer = function(param) {
    var triggerElement = param.triggerElement, caseId = param.caseId, open = param.open, onOpenChange = param.onOpenChange, reloadTrainingPlanById = param.reloadTrainingPlanById, trainingPlan = param.trainingPlan, blurComments = param.blurComments;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommentsDialog/* CommentsDialog */.p, {
        side: CommentsDialog/* Side.Right */.M.Right,
        open: false,
        onOpenChange: onOpenChange,
        triggerElement: triggerElement,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SigninConditionalRenderer/* default */.Z, {
                title: "You must be logged in to add comments",
                buttonText: "Log in to continue",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddReactionForm/* CaseAddReactionForm */.x, {
                    caseId: caseId,
                    afterCommentSubmitted: function() {
                        reloadTrainingPlanById(trainingPlan === null || trainingPlan === void 0 ? void 0 : trainingPlan.id);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentsList/* CaseCommentsList */.j, {
                caseId: caseId,
                blurComments: blurComments
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/ui/typography.tsx
var typography = __webpack_require__(58020);
// EXTERNAL MODULE: ./components/Breadcrumbs.tsx
var Breadcrumbs = __webpack_require__(38383);
// EXTERNAL MODULE: ./features/usersSlice.js
var usersSlice = __webpack_require__(97219);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/users.js
var users = __webpack_require__(49525);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/message-circle.js
var message_circle = __webpack_require__(5097);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/calendar-clock.js
var calendar_clock = __webpack_require__(72175);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/clock-4.js
var clock_4 = __webpack_require__(86871);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/heart.js
var heart = __webpack_require__(57420);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/bookmark.js
var bookmark = __webpack_require__(20816);
// EXTERNAL MODULE: ./components/ui/button.tsx
var ui_button = __webpack_require__(35739);
// EXTERNAL MODULE: ./components/ui/separator.tsx + 1 modules
var separator = __webpack_require__(3127);
// EXTERNAL MODULE: ./util/hooks/useBookmarks.ts
var useBookmarks = __webpack_require__(64616);
// EXTERNAL MODULE: ./components/Toolbox/CommentsSection.tsx
var CommentsSection = __webpack_require__(30346);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./components/Case/CasePage.tsx

































var _obj;
var caseStateMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* CaseStatuses.TENTATIVE */.HM.TENTATIVE, "Schedule"), (0,_define_property/* default */.Z)(_obj, constants/* CaseStatuses.SCHEDULED */.HM.SCHEDULED, "Schedule"), (0,_define_property/* default */.Z)(_obj, constants/* CaseStatuses.NEW */.HM.NEW, "New cases"), (0,_define_property/* default */.Z)(_obj, constants/* CaseStatuses.CLOSED_PRIVATE */.HM.CLOSED_PRIVATE, "Closed"), (0,_define_property/* default */.Z)(_obj, constants/* CaseStatuses.CLOSED */.HM.CLOSED, "Case challenge"), _obj);
var CasePage = function(param) {
    var caseId = param.id;
    var dispatch = (0,es/* useDispatch */.I0)();
    var currentCase = (0,es/* useSelector */.v9)(function(state) {
        return (0,casesSlice/* selectCaseById */.pJ)(state, caseId);
    });
    var ref = (0,react.useState)(false), isCommentsDrawerOpen = ref[0], setIsCommentsDrawerOpen = ref[1];
    var ref1 = (0,react.useState)(false), isParticipantsModalOpen = ref1[0], setIsParticipantsModalOpen = ref1[1];
    var ref2 = (0,useTrainingPlan/* useTrainingPlan */.NQ)(), trainingPlan = ref2.plan, getIsResourcePartOfTheTrainingPlan = ref2.getIsResourcePartOfTheTrainingPlan, getIsResourceCompleted = ref2.getIsResourceCompleted, getIsResourceReviewed = ref2.getIsResourceReviewed, reloadTrainingPlanById = ref2.reloadTrainingPlanById, status = ref2.status;
    var isResourcePartOfTheTrainingPlan = getIsResourcePartOfTheTrainingPlan(caseId);
    var isResourceCompleted = getIsResourceCompleted(caseId);
    var isResourceReviewed = getIsResourceReviewed(caseId);
    var isCaseChallengeSolved = useIsCaseChallengeSolved(currentCase, {
        isTrainingPlanMaterial: isResourcePartOfTheTrainingPlan,
        isCompleted: isResourceCompleted,
        isReviewed: isResourceReviewed
    });
    (0,react.useEffect)(function() {
        if (caseId) {
            dispatch((0,thunks/* fetchCasesById */.QQ)({
                caseId: caseId
            }));
        }
    }, [
        dispatch,
        caseId
    ]);
    if (!caseId || !currentCase) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoTags/* default */.Z, {
                config: {
                    title: "Casehub - ".concat(currentCase.title)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full max-w-screen lg:w-1/2 m-auto pt-8 pb-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                            currentCase: currentCase,
                            setIsCommentsDrawerOpen: setIsCommentsDrawerOpen,
                            setIsParticipantsModalOpen: setIsParticipantsModalOpen,
                            isTrainingPlanMaterial: isResourcePartOfTheTrainingPlan
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                            trainingPlan: trainingPlan,
                            reloadTrainingPlanById: reloadTrainingPlanById,
                            isTrainingPlanLoading: status === "loading",
                            currentCase: currentCase,
                            openCommentsDrawer: function() {
                                return setIsCommentsDrawerOpen(true);
                            },
                            isParticipantsModalOpen: isParticipantsModalOpen,
                            setIsParticipantsModalOpen: setIsParticipantsModalOpen,
                            isTrainingPlanMaterial: isResourcePartOfTheTrainingPlan,
                            isCompleted: isResourceCompleted,
                            isReviewed: isResourceReviewed
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentsDrawer, {
                caseId: caseId,
                open: isCommentsDrawerOpen,
                onOpenChange: setIsCommentsDrawerOpen,
                trainingPlan: trainingPlan || undefined,
                blurComments: !isCaseChallengeSolved,
                reloadTrainingPlanById: reloadTrainingPlanById
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseParticipantsModal/* default */.Z, {
                caseId: caseId,
                open: isParticipantsModalOpen,
                onOpenChange: setIsParticipantsModalOpen
            })
        ]
    });
};
var Header = function(param) {
    var currentCase = param.currentCase, setIsCommentsDrawerOpen = param.setIsCommentsDrawerOpen, setIsParticipantsModalOpen = param.setIsParticipantsModalOpen, isTrainingPlanMaterial = param.isTrainingPlanMaterial;
    var timezone = (0,es/* useSelector */.v9)(timezoneSlice/* selectTimezone */.pE);
    var userId = currentCase.user;
    var user = (0,es/* useSelector */.v9)(function(state) {
        return userId ? (0,usersSlice/* selectUserById */.Ls)(state, userId) : null;
    });
    var isScheduledCase = [
        constants/* CaseStatuses.TENTATIVE */.HM.TENTATIVE,
        constants/* CaseStatuses.SCHEDULED */.HM.SCHEDULED
    ].includes(currentCase.state);
    var isUpcoming = currentCase.scheduled_to && currentCase.scheduled_to > Date.now() / 1000;
    var addToBookmarks = (0,useBookmarks/* useAddCaseBookmarks */.KN)(currentCase.id);
    var addToFavorites = (0,useBookmarks/* useAddCaseToFavorites */.TV)(currentCase.id);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                list: [
                    {
                        id: "group_sessions",
                        name: "Group sessions"
                    },
                    {
                        id: currentCase.id,
                        name: caseStateMap[currentCase.state] || currentCase.state
                    },
                    {
                        id: currentCase.title,
                        name: currentCase.title
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-2 mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex gap-2 mt-4 mb-2",
                        children: isTrainingPlanMaterial ? /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* Badge */.C, {
                            variant: "secondary",
                            className: "bg-teal-200",
                            children: "Part of my training plan"
                        }) : null
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: "h2",
                        asChild: true,
                        className: "pb-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: currentCase.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex gap-1 text-muted-foreground text-xs flex-wrap",
                        children: (0,lodash.uniqBy)(currentCase.expertises || [], "id").map(function(exp) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "#",
                                    exp.title
                                ]
                            });
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center space-x-2 mb-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar/* UserAvatar */.Y, {
                        userId: user === null || user === void 0 ? void 0 : user.id,
                        className: "h-10 w-10"
                    }),
                    user && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-xs font-medium leading-none",
                                children: (0,format/* formatName */.KY)(user)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-xs text-muted-foreground",
                                children: user.position
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
                        variant: "plain",
                        size: "subtle",
                        onClick: function() {
                            setIsParticipantsModalOpen(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(users/* default */.Z, {
                                className: "w-4 h-4"
                            }),
                            currentCase.register_count,
                            "/",
                            currentCase.register_max
                        ]
                    }),
                    !isUpcoming && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
                        variant: "plain",
                        size: "subtle",
                        onClick: function() {
                            setIsCommentsDrawerOpen(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message_circle/* default */.Z, {
                                className: "w-4 h-4"
                            }),
                            currentCase.comment_count
                        ]
                    }),
                    isScheduledCase && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex gap-x-2 text-sm items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(calendar_clock/* default */.Z, {
                                            className: "w-4 h-4"
                                        }),
                                        " ",
                                        (0,format/* formatDate */.p6)({
                                            ts: currentCase.scheduled_to,
                                            format: "long",
                                            tz: timezone
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex gap-x-2 text-sm items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(clock_4/* default */.Z, {
                                            className: "w-4 h-4"
                                        }),
                                        " ",
                                        currentCase.duration || constants/* DEFAULT_SESSION_DURATION_IN_MINUTES */.pg,
                                        " min"
                                    ]
                                })
                            ]
                        })
                    }),
                    currentCase.id ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ml-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                variant: "ghost",
                                size: "subtle",
                                onClick: addToFavorites,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(heart/* default */.Z, {
                                    className: "w-4 h-4",
                                    style: {
                                        fill: currentCase.user_favorite ? "#000" : "none"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                variant: "ghost",
                                size: "subtle",
                                onClick: addToBookmarks,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bookmark/* default */.Z, {
                                    className: "w-4 h-4",
                                    style: {
                                        fill: currentCase.user_bookmark ? "#000" : "none"
                                    }
                                })
                            })
                        ]
                    }) : null
                ]
            }),
            isScheduledCase ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-between my-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterButton/* default */.Z, {
                    caseId: currentCase.id
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(separator/* Separator */.Z, {
                className: "mt-4"
            })
        ]
    });
};
var useIsCaseChallengeSolved = function(currentCase) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _isTrainingPlanMaterial = ref.isTrainingPlanMaterial, isTrainingPlanMaterial = _isTrainingPlanMaterial === void 0 ? false : _isTrainingPlanMaterial, _isCompleted = ref.isCompleted, isCompleted = _isCompleted === void 0 ? false : _isCompleted, _isReviewed = ref.isReviewed, isReviewed = _isReviewed === void 0 ? false : _isReviewed;
    var ref1;
    var auth = (0,util_auth/* useAuth */.aC)();
    var userId = auth === null || auth === void 0 ? void 0 : (ref1 = auth.user) === null || ref1 === void 0 ? void 0 : ref1.id;
    var comments = (0,es/* useSelector */.v9)(function(state) {
        var entries = (0,commentsSlice/* selectCommentEntities */.ol)(state);
        return ((currentCase === null || currentCase === void 0 ? void 0 : currentCase.comments) || []).map(function(id) {
            return entries[id];
        });
    });
    if (!userId || !currentCase) {
        return false;
    }
    if ((currentCase === null || currentCase === void 0 ? void 0 : currentCase.user) === userId) {
        return true;
    }
    if ([
        "ed83cad71b053a12bb423e2825e11221",
        "66eca213dad89464562f5c6fd4641e49",
        "684fa4d54380170fe790632a0643990f", 
    ].includes(userId)) {
        return true;
    }
    if (![
        constants/* CaseStatuses.CLOSED */.HM.CLOSED
    ].includes(currentCase === null || currentCase === void 0 ? void 0 : currentCase.state)) {
        return true;
    }
    if (isTrainingPlanMaterial) {
        return !!(isCompleted || isReviewed);
    }
    return comments.some(function(it) {
        return it.user === userId;
    });
};
var Content = function(param) {
    var currentCase = param.currentCase, openCommentsDrawer = param.openCommentsDrawer, setIsParticipantsModalOpen = param.setIsParticipantsModalOpen, isTrainingPlanMaterial = param.isTrainingPlanMaterial, isTrainingPlanLoading = param.isTrainingPlanLoading, isCompleted = param.isCompleted, isReviewed = param.isReviewed, trainingPlan = param.trainingPlan, reloadTrainingPlanById = param.reloadTrainingPlanById;
    var isCaseChallengeSolved = useIsCaseChallengeSolved(currentCase, {
        isTrainingPlanMaterial: isTrainingPlanMaterial,
        isCompleted: isCompleted,
        isReviewed: isReviewed
    });
    if (!currentCase) {
        return null;
    }
    var isClosedCase = [
        constants/* CaseStatuses.CLOSED */.HM.CLOSED
    ].includes(currentCase.state);
    var allCaseVideos = currentCase.videos || [];
    var caseVideosToShow = allCaseVideos.slice(0, !isCaseChallengeSolved ? 1 : allCaseVideos.length);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-12 lg:space-x-12",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "col-span-12 my-4",
            children: [
                isClosedCase ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSection/* default */.Z, {
                        title: "Instruction",
                        content: "Read the case description and the key question. Watch the below recording of the Q&A session with the case owner.\n" + "Think of possible solutions and write your recommendations to the 'share your ideas' field below.\n" + "After you have done this you can see what other club members have offered and what solution was reached at the actual Casehub session."
                    })
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSection/* default */.Z, {
                    title: "Case description",
                    content: currentCase.content
                }),
                currentCase.key_question ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSection/* default */.Z, {
                    title: "Key question",
                    content: currentCase.key_question
                }) : null,
                currentCase.videos && currentCase.videos.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        caseVideosToShow.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                            variant: "h4",
                            className: "mb-6",
                            children: "Sessions clips"
                        }) : null,
                        caseVideosToShow.map(function(v) {
                            var url = (0,video/* createVideoUrl */.s)(v);
                            var thumb = (0,video/* getVideoThumbnailPath */.y)(v);
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "py-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoCard/* default */.Z, {
                                    title: v.title,
                                    description: v.content,
                                    embedUrl: url,
                                    thumb: thumb,
                                    authRequired: !currentCase.public
                                })
                            }, v.id);
                        })
                    ]
                }) : null,
                isCaseChallengeSolved && currentCase.summary ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSection/* default */.Z, {
                    title: "Case summary",
                    htmlContent: true,
                    content: currentCase.summary
                }) : null,
                function() {
                    if (!isClosedCase) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentsDataProvider, {
                            showCommentsList: !isTrainingPlanLoading,
                            caseId: currentCase.id,
                            afterCommentSubmitted: function() {
                                reloadTrainingPlanById(trainingPlan === null || trainingPlan === void 0 ? void 0 : trainingPlan.id);
                            }
                        });
                    }
                    if (isTrainingPlanMaterial && !isCompleted) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GiveFeedbackCta/* default */.Z, {
                            title: "Your ideas",
                            subtitle: "What solution would you recommend to the case owner? Which CaseHub tools would you suggest the owner use, if any? After submitting your suggestions, you'll see what other Casehub members have offered and what the live session outcome was.",
                            ctaText: "",
                            ctaBefore: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SigninConditionalRenderer/* default */.Z, {
                                    title: "You must be logged in to add comments",
                                    buttonText: "Log in to continue",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddReactionForm/* CaseAddReactionForm */.x, {
                                        caseId: currentCase.id,
                                        placeholder: "How would you solve the case?",
                                        ctaText: "Submit",
                                        onSubmitCommentButtonClick: function() {
                                            openCommentsDrawer();
                                        },
                                        afterCommentSubmitted: function() {
                                            reloadTrainingPlanById(trainingPlan === null || trainingPlan === void 0 ? void 0 : trainingPlan.id);
                                        }
                                    })
                                })
                            })
                        });
                    }
                    if (isTrainingPlanMaterial && isCompleted && !isReviewed) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GiveFeedbackCta/* default */.Z, {
                            title: "Final reflections",
                            subtitle: "After watching the videos and summary, what are your key takeaways? How will you use these learnings in your work going forward? Submit your final reflections to complete this Case Challenge.",
                            ctaText: "",
                            ctaBefore: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SigninConditionalRenderer/* default */.Z, {
                                    title: "You must be logged in to add comments",
                                    buttonText: "Log in to continue",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddReactionForm/* CaseAddReactionForm */.x, {
                                        caseId: currentCase.id,
                                        placeholder: "Share your final reflections",
                                        ctaText: "Submit",
                                        onSubmitCommentButtonClick: function() {
                                            openCommentsDrawer();
                                        },
                                        afterCommentSubmitted: function() {
                                            reloadTrainingPlanById(trainingPlan === null || trainingPlan === void 0 ? void 0 : trainingPlan.id);
                                        }
                                    })
                                })
                            })
                        });
                    }
                    if (!isCaseChallengeSolved) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GiveFeedbackCta/* default */.Z, {
                            title: "How would you solve this case? ",
                            ctaText: "",
                            subtitle: "Which CaseHub tool would you use, and how? After writing your suggestions, you'll see what other Casehub members have offered and what was the live session outcome.",
                            ctaBefore: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SigninConditionalRenderer/* default */.Z, {
                                    title: "You must be logged in to add comments",
                                    buttonText: "Log in to continue",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddReactionForm/* CaseAddReactionForm */.x, {
                                        placeholder: "How would you solve the case?",
                                        caseId: currentCase.id,
                                        ctaText: "Share your ideas",
                                        onSubmitCommentButtonClick: function() {
                                            openCommentsDrawer();
                                        },
                                        afterCommentSubmitted: function() {
                                            reloadTrainingPlanById(trainingPlan === null || trainingPlan === void 0 ? void 0 : trainingPlan.id);
                                        }
                                    })
                                })
                            })
                        });
                    }
                    if (!isTrainingPlanMaterial) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentsDataProvider, {
                            showCommentsList: !isTrainingPlanLoading,
                            caseId: currentCase.id
                        });
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentsDataProvider, {
                                showCommentsList: !isTrainingPlanLoading,
                                caseId: currentCase.id,
                                onSubmitCommentButtonClick: function() {
                                    openCommentsDrawer();
                                },
                                afterCommentSubmitted: function() {
                                    reloadTrainingPlanById(trainingPlan === null || trainingPlan === void 0 ? void 0 : trainingPlan.id);
                                }
                            }),
                             false && /*#__PURE__*/ 0
                        ]
                    });
                }()
            ]
        })
    });
};
var CommentsDataProvider = function(param) {
    var caseId = param.caseId, onSubmitCommentButtonClick = param.onSubmitCommentButtonClick, onSubmitReplyButtonClick = param.onSubmitReplyButtonClick, afterCommentSubmitted = param.afterCommentSubmitted, showCommentsList = param.showCommentsList;
    var currentCase = (0,es/* useSelector */.v9)(function(state) {
        return (0,casesSlice/* selectCaseById */.pJ)(state, caseId);
    });
    var comments = (currentCase === null || currentCase === void 0 ? void 0 : currentCase.comments) || [];
    var dispatch = (0,es/* useDispatch */.I0)();
    var auth = (0,util_auth/* useAuth */.aC)();
    var user = auth === null || auth === void 0 ? void 0 : auth.user;
    if (!currentCase) {
        return null;
    }
    if (!user) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentsSection/* CommentsSection */.o, {
        comments: comments,
        user: auth.user,
        showCommentsList: showCommentsList,
        onSubmitCommentButtonClick: function(text) {
            if (onSubmitCommentButtonClick) {
                onSubmitCommentButtonClick(text);
            }
            dispatch((0,thunks/* commentCase */.rD)({
                caseId: caseId,
                comment: text,
                userId: user.id
            })).then(function() {
                if (afterCommentSubmitted) {
                    afterCommentSubmitted();
                }
            });
        },
        onSubmitReplyButtonClick: function(parentId, text) {
            if (onSubmitReplyButtonClick) {
                onSubmitReplyButtonClick(parentId, text);
            }
            dispatch((0,thunks/* commentCase */.rD)({
                caseId: caseId,
                comment: text,
                userId: user.id,
                parentId: parentId
            })).then(function() {
                if (afterCommentSubmitted) {
                    afterCommentSubmitted();
                }
            });
        },
        onFetchReply: function(commentId) {
            dispatch((0,thunks/* fetchCaseChildComments */.j6)({
                caseId: caseId,
                commentId: commentId
            }));
        }
    });
};
/* harmony default export */ var Case_CasePage = (CasePage);

;// CONCATENATED MODULE: ./pages/case/[id].tsx




function Page() {
    var router = (0,next_router.useRouter)();
    var id = Array.isArray(router.query.id) ? router.query.id[0] : router.query.id;
    if (!id) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Case_CasePage, {
            id: id
        })
    });
}
var __N_SSP = true;
/* harmony default export */ var _id_ = (Page);


/***/ }),

/***/ 64358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useRerenderInterval; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useRerenderInterval = function() {
    var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), counter = ref[0], setCounter = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var interval = setInterval(function() {
            setCounter(counter + 1);
        }, timeout);
        return function() {
            clearInterval(interval);
        };
    }, [
        timeout,
        counter,
        setCounter
    ]);
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7763,6908,6859,9774,2888,179], function() { return __webpack_exec__(36869); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);